







































































































import Vue from "vue";
import { getToplist } from "../utils/apiRequests";
import { Toplist } from "../../../serverless/functions/src/models/toplist";

export default Vue.extend({
  name: "toplist",
  components: {},
  props: {},
  data: () => ({
    dialog: false,
    loading: true,
    toplist: Object() as Toplist,
    wins: [],
    money: [],
    biggestWins: [],
    moneyRecords: []
  }),
  methods: {
    clearCacheArrays() {
      this.wins = [];
      this.money = [];
      this.biggestWins = [];
      this.moneyRecords = [];
    },
    sortCacheArrays() {
      this.wins = this.wins.sort((a, b) => (a.value < b.value ? 1 : -1));
      this.money = this.money.sort((a, b) => (a.value < b.value ? 1 : -1));
      this.biggestWins = this.biggestWins.sort((a, b) =>
        a.value < b.value ? 1 : -1
      );
      this.moneyRecords = this.moneyRecords.sort((a, b) =>
        a.value < b.value ? 1 : -1
      );
    }
  },
  watch: {
    dialog: async function(newValue, oldValue) {
      if (newValue) {
        // Add && !Object.keys(this.toplist).length, then caches toplist and not fetches every time.
        const response: any = await getToplist();
        if (response.success) {
          this.loading = false;
          this.clearCacheArrays();
          this.toplist = response.toplist;
          Object.entries(response.toplist).forEach(([username, stats]) => {
            Object.entries(stats).forEach(([key, value]) => {
              switch (key) {
                case "biggest_win":
                  this.biggestWins.push({ name: username, value: value });
                  break;
                case "money":
                  this.money.push({ name: username, value: value });
                  break;
                case "wins":
                  this.wins.push({ name: username, value: value });
                  break;
                case "money_record":
                  this.moneyRecords.push({ name: username, value: value });
                  break;
              }
            });
          });
          this.sortCacheArrays();
        }
      }
    }
  }
});
